export const isEssentialPagePath = (path: string): boolean => {
  return ['about', 'news', 'faq', 'covid19', 'article', 'reservations'].some((pathSegment) =>
    path.includes(pathSegment)
  );
};
